import { useLang } from "../../contexts/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="main-footer" className="flex justify-between items-center flex-wrap gap-2.5 px-[5.5%] py-[26px] border-t" style={{ borderColor: "var(--kyra-li)" }}>
      <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontWeight: 900, fontSize: 14, letterSpacing: 2, color: "var(--kyra-tx)" }}>KYRA</div>
      <p className="text-[11px]" style={{ color: "var(--kyra-mu)" }}>{t("footer.tagline")}</p>
      <p className="text-[11px]"><a href="mailto:contact@kyra.fr" className="no-underline transition-colors hover:opacity-70" style={{ color: "var(--kyra-mu)" }}>contact@kyra.fr</a></p>
    </footer>
  );
}
